import { HttpLink } from '@apollo/client'
import { GRAPHQL_URI } from '@@partner:config/api'

const httpLink = new HttpLink({
  uri: GRAPHQL_URI,
  credentials: 'include'
})

export default httpLink
